export function getPageHeader() {
  let headerComponent = document.querySelector("lbj-header");
  let pageHeader =
    headerComponent?.shadowRoot?.querySelector(".header__condensed") ||
    document.querySelector(".header__condensed");
  return pageHeader?.clientHeight || 0;
}

export function getDrupalHeader() {
  let drupalHeader = document.querySelector("#toolbar-administration");
  return drupalHeader?.clientHeight || 0;
}

export function getTotalHeaderHeight() {
  return getPageHeader() + getDrupalHeader();
}
